import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OnboardingService } from '../onboarding.service';
import 'firebase/auth'
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TreasuryFormComponent } from './treasury-form-dialog/treasury-form-dialog.component';
import { ImageCroppedEvent, base64ToFile } from 'ngx-image-cropper';
import Talk from 'talkjs';
import { TalkService } from '../talk.service';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { BadgesAwardsService } from 'src/app/core/services/badges-awards/badges-awards.service';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
declare var $: any;
@Component({
  selector: 'app-treasury',
  templateUrl: './treasury.component.html',
  styleUrls: ['./treasury.component.scss']
})
export class TreasuryComponent implements OnInit, OnDestroy, AfterViewInit {
  // form: FormGroup;
  loginForm!: FormGroup;
  submitted = false;
  errMessage: string = '';
  showErrMsg: boolean = false;
  userProfile: any = [];
  awards: any = [];
  userId: any;
  selectedTresures: any;
  publicView: boolean = false;
  @ViewChild('widgetsContent') widgetsContent: ElementRef;
  imageObject: any = [];
  differentUser: boolean = false;
  @ViewChild('pubVidPlayer') videoplayer: ElementRef;
  showControlsVid: boolean = false;
  hidePlayBtnVid: boolean = true;
  @ViewChild('privateVidPlayer') videoplayer1: ElementRef;
  @ViewChild('viewDialog', { static: true }) viewDialog: TemplateRef<any>;
  @ViewChild('deleteDialog', { static: true }) deleteDialog: TemplateRef<any>;
  @ViewChild('hideDialog', { static: true }) hideDialog: TemplateRef<any>;
  @ViewChild('uploadImageDialog', { static: true }) uploadImageDialog: TemplateRef<any>;
  @ViewChild('progressDialog', { static: true }) progressDialog: TemplateRef<any>;
  @ViewChild('target') scrollTarget: any;
  showControlsVid1: boolean = false;
  hidePlayBtnVid1: boolean = false;
  cropImgButton: boolean;
  stopCropper: boolean;
  imageBoxDisable: boolean;
  cropButton: boolean;
  croppedImage: any;
  submitButtonEnabled: boolean;
  finalImage: string;
  cropImgPreview: any;
  imgChangeEvt: string;
  clickedCrop: boolean;
  imageFlag: boolean;
  iconDisabled: boolean = true;
  originalFile: any;
  clickedCropBtn: boolean = false;
  private chatPopup: Talk.Popup;
  open: boolean = false;
  private popup: Talk.Popup;
  private session: Talk.Session;
  badgesArray: any;
  awardUrl: any;
  awardName: any;
  rank:any
  rankUrl: any
  @ViewChild('talkjsContainer') talkjsContainer!: ElementRef;
  userDetails: any;
  isIAMVideoUpvoted:boolean=false;
  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private router: Router,
    private onboardingService: OnboardingService,
    private activatedRoute: ActivatedRoute,
    private talkService: TalkService,
    private spotlightService: SpotlightService,
    private badgeService: BadgesAwardsService,
    private adminService: AdminService,
    private spinner: NgxSpinnerService,
    private service : AuthenticationService
  ) {

  }
  ngOnInit(): void {

      this.service.checkUserAuthenticated().subscribe((res) => {
        if (this.router.url.includes('myTreasures')) {
          this.userId = res.userId.toString();
        }
        else{
          this.userId = this.activatedRoute.snapshot.paramMap.get('id')
        }
        
        let userId = this.userId

       this.badgeService.getUserBadges(userId).subscribe((res:any)=>{
        // console.log('res',res.previousBadges);
        this.badgesArray = res.reverse()
        this.badgesArray.forEach((awards:any)=>{
          // console.log('awards here',awards);
          this.awardUrl = awards.badgeurl;
          this.awardName = awards.badgename;
          // console.log('awards here',this.awardUrl, this.awardName);
        })
      })
  
      this.onboardingService.getShowcases().subscribe((res) => {
        if (res.user.toString() !== userId) {
          this.differentUser = true;
          this.publicView = true;
        }
        this.onboardingService.getUserProfile(userId).subscribe((res1) => {
          // console.log(res1)
          this.userProfile = res1;
          this.userId = userId;
          this.rank = res1.title
          const matching = this.badgesArray.find(obj=> obj.badgename === this.rank);
  
          if(matching){
          this.rankUrl = matching.badgeurl
          }
  
          if (this.userProfile.imVideoUrl) {
            this.userProfile.imVideoUrl = this.userProfile.imVideoUrl + '#t=0.001'
            this.getIAMVideoUpvoteDetails()
          }
          this.awards = res1.awards;
          if (this.router.url.includes('myTreasures')) {
            let scroll = document.getElementById('tresures')
            this.scroll(scroll)
          }
          this.badgesArray.map((p) => {
            // console.log('p here',p)
            this.imageObject.push({
              image: p.badgename ? p.badgeurl : 'assets/images/circle-transperant.png',
              thumbImage: p.badgename ? p.badgeurl : 'assets/images/circle-transperant.png',
              alt: 'alt of image',
              title: p.badgename
            })
          })
          // console.log(this.imageObject)
        }, err => {
  
        })
      }, err => {
  
      })
      window.onbeforeunload = () => this.ngOnDestroy();
  
  
  
      this.loginForm = this.formBuilder.group({
        emailAddress: ['', Validators.compose([Validators.required, Validators.email])],
        password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(30)])],
        'remember-me': true
      });

      })

  
  }


  openDialog(event: any) {
    event.stopPropagation();
    let dialogRef = this.dialog.open(TreasuryFormComponent, {
      width: '650px',
      data: this.selectedTresures
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectedTresures = undefined
      this.onboardingService.getShowcases().subscribe((res: any) => {
        this.userId = res.user
        this.onboardingService.getUserProfile(res.user).subscribe((res1) => {
          // console.log(res1)
          this.userProfile = res1;
          this.awards = res1.awards;
        }, err => {

        })
      });
    })
  }

  onFileSelectProfile() {
    this.dialog.open(this.progressDialog)
    let file: File = this.croppedImage;
    let formData: FormData = new FormData();
    formData.append('picture', file, file.name)
    this.onboardingService.uploadProfile(this.userId, formData).subscribe((res) => {
      console.log(res);
      this.dialog.closeAll()
      this.getUserDetails()
      this.cropImgPreview = ''
      this.croppedImage = '';
      this.clickedCropBtn = false;
      this.iconDisabled = true;
      this.imgChangeEvt = ''
      this.onboardingService.profilePic$.next(true)
      window.location.reload()
    })
  }

  ngAfterViewInit() { }

  onFileSelectBackground(event: any) {
    let fileList: FileList = event.target.files;
    if (fileList.length < 1) {
      return;
    }

    let file: File = fileList[0];
    let formData: FormData = new FormData();
    formData.append('file', file)
    this.onboardingService.uploadBackgroundPic(formData).subscribe((res) => {
      // console.log(res);
      this.getUserDetails()
      window.location.reload()
    }, err => {
      this.getUserDetails()
    })
  }

  getUserDetails() {
    this.onboardingService.getShowcases().subscribe((res: any) => {
      this.onboardingService.getUserProfile(res.user).subscribe((res1) => {
        // console.log(res1)
        this.userProfile = res1;
        this.awards = res1.awards;
      }, err => {

      })
    }, err => {

    })
  }

  toggleView() {
    this.publicView = !this.publicView
  }

  redirectToIAM() {
    this.router.navigate(['/userProfiles/' + this.userId + '/setup/4'], { queryParams: { iAmVideo: false } });
  }

  deleteTresures(item: any) {
    event.stopPropagation();

    this.onboardingService.deleteTresurey(item.id, this.userId).subscribe((res) => {
      this.dialog.closeAll()
      this.getUserDetails()
    }, err => {

    })
  }

  deleteTresuresConfirmation(event, item: any) {
    event.stopPropagation();
    this.dialog.open(this.deleteDialog, { data: item });
  }

  hideTresures(item) {
    event.stopPropagation();
    this.onboardingService.hideTresurey(item.id, this.userId).subscribe((res) => {
      this.dialog.closeAll()
      this.getUserDetails()
    }, err => {

    })
  }

  hideTresuresConfirmation(event, item: any) {
    event.stopPropagation();
    this.dialog.open(this.hideDialog, { data: item });
  }

  scrollLeft() {
    this.widgetsContent.nativeElement.scrollLeft -= 150;
  }

  scrollRight() {
    this.widgetsContent.nativeElement.scrollLeft += 150;
  }

  getTresuries() {
    if (this.userProfile?.treasuries?.length <= 0) {
      return false;
    }

    if (this.userProfile?.treasuries?.length > 0) {
      return true;
    }

    let item = this.userProfile?.treasuries?.filter((p) => p.hidden == true)
    if (item?.length > 0) {
      return true;
    }
    return false;
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  playVideo() {
    this.showControlsVid1 = true;
    this.hidePlayBtnVid1 = true
    this.videoplayer1.nativeElement.play()
  }

  videoEndedVid1() {
    this.hidePlayBtnVid1 = true;
    this.showControlsVid1 = true;
  }

  playVideoForPublic() {
    this.showControlsVid = true;
    this.hidePlayBtnVid = true
    this.videoplayer.nativeElement.play()
  }

  videoEndedForPublic() {
    this.hidePlayBtnVid = false;
    this.showControlsVid = true;
  }

  openDialogForViewTresures() {

    // console.log(this.selectedTresure
    console.log(this.selectedTresures)
    this.getUpvote()
    this.dialog.open(this.viewDialog);
  }

  openUploadProfileImage() {
    this.dialog.open(this.uploadImageDialog).afterClosed().subscribe((res) => {
      window.location.reload()
    });
  }

  onFileChange(event: any): void {
    this.imgChangeEvt = event;
    // console.log(event)

    this.stopCropper = true;
    this.imageFlag = true;
    this.iconDisabled = false;
    if (!this.cropImgPreview) {
      this.clickedCrop = true;
    }
    this.clickedCrop = false;

    this.originalFile = event.target.files[0];
    // console.log(this.originalFile)

    if (event.target.files[0].size >= 41943040) {
      // console.log(event.target.files[0].size)

      alert("File size is too big")
      this.imageFlag = false;
      this.imgChangeEvt = '';
      this.iconDisabled = true;
      this.clickedCrop = true;
    }
    else {

    }
  }
  click() {
    if (!this.cropImgPreview) {
      this.clickedCrop = true;
    }
    this.stopCropper = true;
    this.cropButton = true;
  }

  imageCropped(event: ImageCroppedEvent, file: any) {

    this.cropImgPreview = event.base64;
    this.croppedImage = this.cropImgPreview;

  }

  imgLoad() {
    // display cropper tool
  }
  initCropper() {
    // init cropper
  }

  imgFailed() {
    // error msg
  }
  cropImage(file: any) {
    this.cropImgButton = false;
    this.clickedCropBtn = true;
    this.stopCropper = false;
    this.imageBoxDisable = false
    this.cropButton = false;
    this.submitButtonEnabled = true;
    this.croppedImage = base64ToFile(this.croppedImage);
    this.finalImage = URL.createObjectURL(this.croppedImage);
    let mysrc;
    const reader = new FileReader();
    reader.readAsDataURL(this.croppedImage);
    reader.onloadend = function () {
      mysrc = reader.result;
    }
    mysrc = this.croppedImage

    // console.log(this.croppedImage)

  }

  goToLink(link) {
    let url: string = '';
    if (!/^http[s]?:\/\//.test(link)) {
      url += 'http://';
    }

    url += link;
    window.open(url, '_blank');
    // window.location.href=link;

  }

  editIamVideo() {
    this.router.navigate(['/userProfiles/' + this.userId + '/setup/4'], { queryParams: { iAmVideo: false } });

  }

  getName(item: any) {
    return item.split("&")[0];
  }

  redirectToChat() {
    this.router.navigate(['/my-inbox'])
  }


  async showChatPopup() {


    if (this.popup) {
      this.popup.show()
    }
    if (!this.popup) {
      const otherUser = {
        id: this.activatedRoute.snapshot.paramMap.get('id'),
        username: this.userProfile.firstName + this.userProfile.lastName,
        photoUrl: this.userProfile.profilePic,
        label: 'profile'
      }
      const session = await this.talkService.createCurrentSession();
      this.popup = await this.talkService.createPopup(otherUser, session);

      // console.log(this.popup)

      console.log(this.popup
      )

      this.popup.mount(this.talkjsContainer.nativeElement);
      this.popup.show()
    }
    console.log(document.getElementsByTagName('iframe').length)
    if (window.matchMedia("(max-width: 600px)").matches) {
      /* the viewport is at least 400 pixels wide */
      for (let i = 0; i <= document.getElementsByTagName('iframe').length; i++) {
        if (document.getElementsByTagName('iframe')[i]['style']) {
          document.getElementsByTagName('iframe')[i]['style'].minHeight = '95vh'
          document.getElementsByTagName('iframe')[i]['style'].maxHeight = '95vh'
        }
      }
    }
    this.popup.on('close', (() => {
      // console.log('close')
      this.popup.hide();
    }))

  }

  ngOnDestroy() {
    this.popup?.destroy()
    this.talkService.destroyAllLoadedPopups()
  }

  openAddNewDialog(event: any) {
    event.stopPropagation();
    let dialogRef = this.dialog.open(TreasuryFormComponent, {
      width: '650px'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectedTresures = undefined
      this.onboardingService.getShowcases().subscribe((res: any) => {
        this.userId = res.user
        this.onboardingService.getUserProfile(res.user).subscribe((res1) => {
          console.log(res1)
          this.userProfile = res1;
          this.awards = res1.awards;
        }, err => {

        })
      });
    })
  }

  postUpvote() {
    this.spinner.show();
    this.adminService.getCreaticsHomepageLoggedIn().subscribe((profileres: any) => {
      console.log(profileres, profileres.userUpvoteBalance)
      if (profileres.userUpvoteBalance > 0) {
        this.onboardingService.postUpvote({ treasuryId: this.selectedTresures.id }).subscribe((res: any) => {
          this.selectedTresures['upvoted'] = "true";
          alert(`Congratulations, you got 5 currency points! Your free Jewel balance for today is ${profileres.userUpvoteBalance - 1}.`)
          this.spinner.hide();
        }, err => {
          console.log(err)
          alert('You have already jeweled this treasury')
          this.spinner.hide();
        })
      } else {
        alert('You have already exhausted your jewel balance')
        this.spinner.hide();
      }

    },
      (err) => {
        alert("Something went wrong!")
        this.spinner.hide();
      })

  }

  getUpvote() {
    this.onboardingService.getTresureyVotingByTresureyId(this.selectedTresures.id).subscribe((res) => {
      this.selectedTresures['upvoted'] = res;
      console.log(res, this.selectedTresures)
    }, err => {

    })
  }

  postIAMVideoUpvote() {
    this.spinner.show();
    this.onboardingService.getUpvoteBalance().subscribe((result) => {
      let obj = { videoCreatorId: this.userId, activity: "vote_video" }
      if(!this.isIAMVideoUpvoted){
        if(parseInt(result) > 0){
          this.onboardingService.postUpvoteForIAMVideo(obj).subscribe((res) => {
            alert(`Congratulations, you got 5 currency points! Your free Upvotes balance for today is ${parseInt(result) - 1}.`)
            this.getIAMVideoUpvoteDetails()
          }, err => {
            this.spinner.hide();
            alert("You have already jeweled this video")
          })
        }else{
          this.spinner.hide();
          alert("You have already exhausted your jewel balance")
        }
      }else{
        this.spinner.hide();
        alert("You have already jeweled this video")
      }
    }, err => {
      this.spinner.hide();
    })
  }

  getIAMVideoUpvoteDetails() {
    this.onboardingService.getUpvoteDetailsForIAMVideo(this.userId).subscribe((res) => {
      let item = JSON.parse(res)
      if(item && item.isRated == 1){
        this.isIAMVideoUpvoted = true;
      }else{
        this.isIAMVideoUpvoted = false;
      }
      this.spinner.hide();
    }, err => {

    })
  }
}
